import { setCustomHotReload } from '@lorcana/engine';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App.tsx';
import './index.css';

// Under Vite dev, a hot-swapped card module reruns its top-level `registerCustom` call with a
// freshly constructed generator function — tolerate that here so HMR doesn't die on it. Off in
// `vite build` and everywhere else, where `import.meta.hot` is undefined and a genuine `id`
// collision between two cards should still fail loudly (`custom.ts`).
setCustomHotReload(import.meta.hot !== undefined);

const container = document.getElementById('root');
if (!container) {
  throw new Error('#root missing from index.html');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
